import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { SwapOutlined } from '@ant-design/icons';
import { Alert } from 'antd';
import { useGetAssignedProjectsQuery, useGetIngProjectQuery } from '../../../../../redux/services/ing_projects.jsx';
import { CollapseBlock, Spinner } from '../../../../common/index.jsx';
import { AppBarCMS } from '../../../../basic/index.jsx';
import IngProjectsDetail from '../../../../common/IngProjects/IngProjectsDetail.jsx';
import IpChangeRequestCreateModal from './IpChangeRequestCreateModal.jsx';

const IngProjectsAssignedPage = () => {
  const { t } = useTranslation();
  const [changeModalVisible, setChangeModalVisible] = useState(false);

  useEffect(() => {
    document.title = t('Priradený projekt') + ' | FRI UNIZA';
  }, [t]);

  const { data: assignedProjects, isLoading: isLoadingAssigned } = useGetAssignedProjectsQuery();

  // Get the first assigned project's ID
  const assignedProjectId = assignedProjects?.[0]?.ip_project_id;

  // Load full project details
  const { data: project, isLoading: isLoadingProject } = useGetIngProjectQuery(assignedProjectId, {
    skip: !assignedProjectId,
  });

  const mainActions = useMemo(() => {
    if (!assignedProjectId) return [];
    return [
      {
        title: t('Chcem zmeniť projekt'),
        icon: <SwapOutlined />,
        onClick: () => setChangeModalVisible(true),
        permission: 'ing-projects-student',
      },
    ];
  }, [assignedProjectId, t]);

  if (isLoadingAssigned || isLoadingProject) {
    return <Spinner />;
  }

  if (!assignedProjects || assignedProjects.length === 0) {
    return (
      <>
        <AppBarCMS
          title={t('Priradený projekt')}
          backUrl={-1}
          backUrlTooltip={t('Späť')}
        />
        <div style={{ margin: '10px' }}>
          <CollapseBlock title={t('Priradený projekt')}>
            <p>{t('Nemáte žiadny priradený projekt')}</p>
          </CollapseBlock>
        </div>
      </>
    );
  }

  return (
    <>
      <AppBarCMS
        title={t('Priradený projekt')}
        backUrl={-1}
        backUrlTooltip={t('Späť')}
        mainActions={mainActions}
      />

      {project && (
        <IngProjectsDetail
          project={project}
          beforeContent={(
            <Alert
              type="success"
              showIcon
              title={t('Boli ste priradená/ý na projekt')}
              description={(
                <>
                  {t('Názov projektu projektu na ktorý ste pripradený je ')} <strong>{project?.name ?? assignedProjects?.[0]?.project?.name}</strong>.
                  {' '}
                  {t('Ak chcete')}
                  {' '}
                  <strong>{t('požiadať o zmenu')}</strong>
                  {' '}
                  {t('projektu, použite ikonu')}
                  {' '}
                  <SwapOutlined />
                  {' '}
                  {t('vpravo hore.')}
                </>
              )}
              style={{ marginBottom: 12 }}
            />
          )}
        />
      )}

      <IpChangeRequestCreateModal
        visible={changeModalVisible}
        onClose={() => setChangeModalVisible(false)}
        currentProjectId={assignedProjectId}
        currentStudyProgramId={assignedProjects?.[0]?.study_program_id}
      />
    </>
  );
};

export default IngProjectsAssignedPage;
